export const faqs = [
  {
    id: "faq-track-what",
    question: "「网曝吃瓜」到底追踪的是什么？",
    answer:
      "我们追踪的是网络上已经形成一定讨论规模的话题事件，重点不在最初的爆料本身，而在于事件之后发生了什么：当事方是否回应、相关方如何说明、讨论出现了哪些新的转折，以及最终是否有了明确结论。每条档案都会把这些节点按时间排列出来。",
    group: "平台说明",
  },
  {
    id: "faq-update-frequency",
    question: "事件的进展多久更新一次？",
    answer:
      "更新频率取决于话题热度。热度值越高的事件，通常每几小时就会补充一个节点；热度回落后会转为每日汇总。每份档案页顶部的「最近更新」时间代表该档案最后一次信息补录的时间点。",
    group: "平台说明",
  },
  {
    id: "faq-heat-meaning",
    question: "热度值是怎么算出来的？",
    answer:
      "热度是一个综合指标，主要参考话题在公开渠道的讨论数量、跨平台出现频率以及持续时长，再折算为一万以内的数值。它只用于排序和对比，不代表我们对事件的态度，也不等于事件的重要性评价。",
    group: "平台说明",
  },
  {
    id: "faq-status-tag",
    question: "档案上的状态标签分别代表什么？",
    answer:
      "「发酵中」表示讨论仍在扩大且暂无明确结论；「已回应」表示当事方或相关方已经公开说明；「已澄清」表示关键争议点已经有可核实的结论；「持续追踪」表示事件跨度较长、会长期跟进；「热度回落」表示讨论规模明显下降。",
    group: "平台说明",
  },
  {
    id: "faq-neutral",
    question: "你们会不会对事件给出立场或结论？",
    answer:
      "不会。平台只做信息梳理，不替任何一方下判断。我们会明确区分「有出处的公开信息」和「尚未证实的说法」，并在正文中标注信息来源类型。遇到互相矛盾的说法，我们并列呈现而不是替读者选择。",
    group: "内容原则",
  },
  {
    id: "faq-source",
    question: "档案里的信息都来自哪里？",
    answer:
      "主要来自当事方或相关机构的公开声明、主流媒体的报道，以及公开可查的原始材料。对于无法追溯到具体出处的说法，我们不会写入时间线，只会在必要时以「未经证实」的形式提示读者谨慎看待。",
    group: "内容原则",
  },
  {
    id: "faq-real-person",
    question: "会涉及具体的人或企业吗？",
    answer:
      "平台以话题和现象为观察对象，聚焦事件本身的脉络，不对未涉入公共讨论的个人进行信息展示。涉及具体主体时，我们只转述已公开的、与事件进展直接相关的信息。",
    group: "内容原则",
  },
  {
    id: "faq-correction",
    question: "如果发现内容有误怎么办？",
    answer:
      "每份档案页底部都有纠错入口，也可以通过联系邮箱提交。收到反馈后我们会核对原始出处，确认有误会在页面顶部标注更正说明，并把修正记录保留在时间线里，方便读者对照。",
    group: "内容原则",
  },
  {
    id: "faq-search",
    question: "怎么快速找到我关心的事件？",
    answer:
      "可以在话题档案页使用关键词搜索，支持按事件名称或标签匹配；也可以先选分类再浏览，或者直接按状态标签筛出「已回应」「持续追踪」等特定阶段的话题。",
    group: "使用帮助",
  },
  {
    id: "faq-timeline-read",
    question: "时间线应该从哪一头开始看？",
    answer:
      "如果你刚开始关注，建议从下往上读，先看事件起点的背景，再看后续如何演变；如果你只想了解最新情况，则从上往下读，顶部就是最近一次更新。时间线中带方括号的节点表示有明确出处的关键节点。",
    group: "使用帮助",
  },
  {
    id: "faq-subscribe",
    question: "订阅更新提醒会收到什么？",
    answer:
      "订阅后我们会按日汇总你关注分类下的新进展，通常是每天一封，内容包含新增节点摘要与直达链接。不会发送与话题追踪无关的推广信息，也可以随时通过邮件底部的链接退订。",
    group: "使用帮助",
  },
  {
    id: "faq-mobile",
    question: "手机上浏览体验如何？",
    answer:
      "全站都按响应式设计，手机端会自动切换为单列布局，时间线改为紧凑样式，导航折叠为菜单按钮。搜索、分类筛选与折叠问答在移动端都完整可用。",
    group: "使用帮助",
  },
];